import styled from "styled-components";
import NoTextSelectionStyles from "../../../common/styles/no-text-selection";

const HeroSC = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 16px;
    width: 100%;

    .hero-holder {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        background: #f0f5d7ff;
        gap: 16px;
        width: 90%;
        height: 700px;
        border-radius: 16px;
        gap: 24px;
        ${NoTextSelectionStyles}
    }

    .hero-content-holder {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 40%;
    }

    .greeting-text {
        font-size: 24px;
        font-weight: 600;
    }

    .brand-name {
        font-size: 48px;
        font-weight: 600;
    }

    .description {
        font-size: 18px;
        font-weight: 400;
        width: 75%;
        line-height: 28px;
        letter-spacing: 0.5px;
        margin-bottom: 4px;
        display: flex;
        flex-direction: column;
        gap: 14px;
        margin-bottom: 16px;

        h1 {
            font-size: 18px;
            font-weight: 400;
            line-height: 28px;
            letter-spacing: 0.5px;
            margin: 0px;
            padding: 0px;
        }
    }

    .image-gallery {
        width: 600px;
    }

    .stack-container {
        position: relative;
        height: 500px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .stack-image {
        position: absolute;
        width: 700px;
        object-fit: cover;
        opacity: 0;
        transition: opacity 1s ease;
        border-radius: 16px;
        height: 500px;
    }

    .stack-image.visible {
        opacity: 1;
    }

    @media (max-width: 768px) {
        .hero-holder {
            flex-direction: column;
            background: #f0f5d7ff;
            gap: 16px;
            width: calc(100% - 32px);
            height: unset;
            gap: 24px;
            padding: 32px 0px;
        }

        .hero-content-holder {
            gap: 8px;
            width: 90%;
        }

        .brand-name {
            font-size: 22px;
            margin-top: -16px;
            margin-bottom: 16px;
            text-align: center;
        }

        .description {
            font-size: 14px;
            font-weight: 400;
            width: 100%;
            line-height: 22px;
            letter-spacing: 0.2px;
            gap: 12px;
            margin-bottom: 16px;
            text-align: justify;
            color: #353434;
        }

        .image-gallery {
            width: 100%;
            height: 220px;
            margin-top: unset;
        }

        .stack-container {
            position: relative;
            width: 100%;
            display: flex;
            height: 220px;
            align-items: unset;
        }

        .stack-image {
            position: absolute;
            object-fit: cover;
            opacity: 0;
            transition: opacity 1s ease;
            border-radius: 16px;
            width: 90%;
            height: 200px;
        }

        .stack-image.visible {
            opacity: 1;
        }

    }
`;

export default HeroSC;